import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type CreateContainerCargoItemMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateContainerCargoItemInput;
}>;

export type CreateContainerCargoItemMutationResult = { __typename?: 'Mutation' } & {
  cargoCreateContainerCargoItem?: GraphQLTypes.Maybe<
    { __typename?: 'CreateContainerCargoItemPayload' } & {
      cargoItem?: GraphQLTypes.Maybe<
        | ({ __typename?: 'CargoContainerType' } & Pick<GraphQLTypes.CargoContainerType, 'id'>)
        | ({ __typename?: 'CargoLooseCargoType' } & Pick<GraphQLTypes.CargoLooseCargoType, 'id'>)
        | ({ __typename?: 'CargoVehicleType' } & Pick<GraphQLTypes.CargoVehicleType, 'id'>)
      >;
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const CreateContainerCargoItemDocument = gql`
  mutation createContainerCargoItem($input: CreateContainerCargoItemInput!) {
    cargoCreateContainerCargoItem(input: $input) {
      cargoItem {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;
